export const wordCloudsPath = "/word-clouds"
